import { useEffect, useState } from "react";
import { endpoint } from "views/pages/manage/common/constant";
import useCashierOfficeDropdown from "views/pages/manage/common/hook/useCashierOfficeDropdown";
import { dropdownMapping } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

export const useFetchDropdown = (setIsDropdownLoading=()=>{}) => {
  const [dropdownValues, setDropdownValues] = useState({
    terms: [],
    businessAreas: [],
    cashierOffices: [],
  });
  const [isLoading, setIsLoading] = useState(false);

  const { items } = useCashierOfficeDropdown({
    label: "Cashier office",
    formHandler: () => {},
    inputHeight: "9px",
  });

  useEffect(() => {
    const fetchStaticDropdowns = async () => {
      try {
        setIsLoading(true);
        const [businessAreas] = await Promise.all([
          dropdownMapping(
            endpoint.businessArea.getAllActiveV2,
            "businessAreaDispValue",
            "businessAreaDispValue",
            "businessAreaDesc",
            "businessUnitTypeId"
          ),
        ]);

        setDropdownValues((prev) => ({
          ...prev,
          businessAreas,
        }));
        setIsDropdownLoading(true);
        setIsLoading(false);
      } catch (err) {
        console.error("Failed to fetch dropdowns:", err);
      }
    };

    fetchStaticDropdowns();
  }, []);

  useEffect(() => {
    if (!items) return;

    setDropdownValues((prev) => ({
      ...prev,
      cashierOffices: items,
    }));
  }, [items]);

  return { dropdownValues, isDropdownApiLoading:isLoading };
};

export const useBusinessAreaDropdown = () => {
  const [businessAreas, setBusinessAreas] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchBusinessAreas = async () => {
      try {
        setIsLoading(true);
        const areas = await dropdownMapping(
          endpoint.businessArea.getAllActiveV2,
          "businessAreaDispValue",
          "businessAreaDispValue",
          "businessAreaDesc"
        );
        setBusinessAreas(areas);
      } catch (err) {
        console.error("Failed to fetch business areas:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchBusinessAreas();
  }, []);

  return { businessAreas, isLoading };
};